import React from 'react';

export default function MyVideos() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">My Videos</h1>
      <p>My Videos page not implemented yet.</p>
    </div>
  );
}